import React from 'react'
import About_1 from '../../../assets/images/home_page_4/about/01.png'

const About = () => {
    return (
        <>
            <section id="about-us" className="about-us-main-block">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12">
                            <div className="about-us-img">
                                <img
                                    src={About_1}
                                    className="img-fluid"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="about-us-block">
                                <h6 className="about-sub-heading hr-lines">Lawpro Solutions</h6>
                                <h1 className="about-main-heading">
                                    Advocates for justice and equality
                                </h1>
                                <p className="about-dtls">
                                    Our mission is there are many variations of passages of Lorem Ipsum
                                    available, but the majority have suffered alteration Our mission is
                                    there are many variations of passages of Lorem Ipsum available, but
                                    the majority have suffered alteration
                                </p>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <h3 className="about-title">Digital Boost Pro</h3>
                                        <p className="about-dtls">
                                            Lorem is Ipsum is simply is design iomyi is text Lorem Ipsum is
                                            simply is our busi designer is our country.
                                        </p>
                                    </div>
                                    <div className="col-lg-6">
                                        <h3 className="about-title">WebWise Solutions</h3>
                                        <p className="about-dtls">
                                            Lorem is Ipsum is simply is design iomyi is text Lorem Ipsum is
                                            simply is our busi designer is our country.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default About
